import {useState} from "react";
import '../styles/_form-with-btn.module.scss'; 

const LetsStart = () => {
    const [email, setEmail] = useState('');
    const [emailError, setEmailError] = useState('');

    const validateEmail = (email: string) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };

    const handleButtonClick = () => {
        if (!validateEmail(email)) {
            setEmailError('error');
            return;
        }

        setEmailError('');
        window.open(`https://app.middleware.io/auth/register`, '_blank');
        setEmail("");
    };

    return (
        <>
            <div className={"form-with-btn"}>
                <input
                    type={"text"}
                    placeholder={"Enter your email to start"}
                    className={emailError}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <button
                    className={"ahref-btn primary"}
                    onClick={handleButtonClick}
                >
                    Let's Start
                </button>
            </div>
        </>
    )
}

export default LetsStart